import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { ApolloProvider } from "@apollo/client";
import { ClerkProvider } from "@clerk/clerk-react";
import { HelmetProvider } from "react-helmet-async";
import { useApolloClient } from "./hooks/useApolloClient";
import AnalyticsBootstrap from "./components/AnalyticsBootstrap";

// Get the Clerk publishable key from environment variables
const clerkPubKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string;

if (!clerkPubKey) {
  throw new Error("Missing Publishable Key");
}

// Component that provides Apollo Client with authentication
const ApolloWrapper: React.FC = () => {
  const client = useApolloClient();
  
  return (
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ClerkProvider publishableKey={clerkPubKey}>
        <AnalyticsBootstrap />
        <ApolloWrapper />
      </ClerkProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// Register service worker for PWA support (production only)
serviceWorkerRegistration.register({
  onUpdate: () => {
    window.dispatchEvent(new CustomEvent("sw-update-available"));
  },
});
